// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1A4bA","inputWrap":"Table_inputWrap__InRld","col":"Table_col__2jWW4","bmiTooltip":"Table_bmiTooltip__1UE8E"};